<!--  -->
<template>
  <div class="MyLoadHeadTab">
      <div
        v-for="(e, index) in tabArray"
        :key="e"
        :class="{ active: index === activeIndex }"
        @click="switchClick(index)"
      >
        <div class="MyLoadHeadTab_text">{{ e }}</div>
        <div
          class="MyLoadHeadTab_line_grey"
          :class="{ MyLoadHeadTab_line: index === activeIndex }"
        ></div>
      </div>
    </div>
</template>

<script>
import defaultImg from '@/assets/images/default.jpg';

export default {
  name: 'MyLoadHead',
  data() {
    return {
      tabArray: ['已授信', '未授信', '聚合订单'],
      ImgUrl: '',
      name: '',
    };
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.download();
    this.name = localStorage.getItem('name');
  },
  methods: {
    switchClick(i) {
      this.$emit('setActiveIndex', i);
    },
    mySetHeadle() {
      this.$router.push('/supermarket/v2/myset');
    },
    download() {
      this.$api.PublicPage.download({
        url: localStorage.getItem('urlHref'),
      })
        .then((res) => {
          if (res.success) {
            this.addUerInfoImg(res);
          }
        })
        .catch(() => {
        });
    },
    addUerInfoImg(res) {
      if (res.success) {
        let str = '';
        if (res.data.type === 'png') {
          str = `data:image/png;base64,${res.data.file}`;
        } else if (res.data.type === 'jpg') {
          str = `data:image/jpg;base64,${res.data.file}`;
        } else {
          str = `data:image/jpeg;base64,${res.data.file}`;
        }
        this.ImgUrl = str;
        localStorage.setItem('url1', str);
      } else {
        this.ImgUrl = defaultImg;
      }
    },
  },
};
</script>
<style scoped>
.MyLoadHead {
  background-image: linear-gradient(-86deg, #f5514a 2%, #f5683c 100%);
  height: 100%;
  border-radius: 0 0 25px 25px;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
}
.MyLoadHead_name {
  color: #fff;
  font-size: 14px;
}
.MyLoadHeadUserInfo {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.MyLoadHeadUserInfoPic {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.MyLoadHeadImage {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 16px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.MyLoadHeadImage img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.MyLoadHeadTab {
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
  background: #fff;
  height: 48px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  border-radius: 3px 3px 0 0;
  margin: 8px 16px;
  font-size: 16px;
}
.MyLoadHeadTab > div {
  height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
}
.MyLoadHeadTab_text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  font-size: 16px;
  font-family: PingFangSC-Regular;
}
.MyLoadHeadTab_line {
  background: #f56446;
}
.MyLoadHeadTab_line_grey {
  width: 50px;
  height: 3px;
}
.active {
  font-family: PingFangSC-Medium;
  font-size: 32px;
  color: #f56446;
}
.mySet {
  color: #fff;
  font-size: 22px;
}
</style>
